import { newIntegrationInitialValues } from "../../schemas/initialValues";
import { integrationsValidations } from "../../schemas/validations";
import { Formik, Form } from "formik";
import FormField from "cxfcomponents/FormField";
import { useIntegrations } from "hooks/useIntegrations";
import { integration as integrationField } from "../../schemas/integration";
import { truncateInputValue } from "helpers/fieldListeners";
import SoftBox from "components/SoftBox";
import defaultIntegrationIcon from "assets/images/integration.svg";
import { EditPictureMenu } from "components/Picture/Edit";

export const FormStep = ({
  handleFormStepSubmit,
  initialValues,
  ref,
  setPictureUpload,
  pictureUpload,
  integration
}) => {
  const {
    formId,
    formField: { integrationName, description, version }
  } = integrationField;
  const { integrations } = useIntegrations();

  const validateIntegrationName = (value) => {
    if (!value) {
      return `${integrationName.label} is required.`;
    }

    if (integrations.length) {
      const integrationExist = integrations.some(
        (integration) =>
          initialValues?.integrationName !== integration.integration_name &&
          integration.integration_name.toLowerCase() === value.toLowerCase()
      );

      if (integrationExist) {
        return `${value} already exists.`;
      }
    }
  };

  return (
    <Formik
      initialValues={initialValues ? initialValues : newIntegrationInitialValues}
      validationSchema={integrationsValidations}
      onSubmit={handleFormStepSubmit}
      innerRef={ref}
    >
      {({ errors }) => {
        return (
          <Form id={formId} autoComplete="off">
            <SoftBox
              className="border-top"
              sx={{
                alignItems: "flex-start",
                display: "flex",
                paddingTop: "20px"
              }}
            >
              <EditPictureMenu
                pictureUpload={pictureUpload}
                setPictureUpload={setPictureUpload}
                value={integration?.logo}
                params={integration?.updated_date_time ?? ""}
                defaultPicture={defaultIntegrationIcon}
              />
              <SoftBox
                sx={{
                  flexGrow: 1,
                  transform: "translateY(-12px)"
                }}
              >
                <FormField
                  id="integrationName"
                  type={integrationName.type}
                  label={integrationName.label}
                  name={integrationName.name}
                  validate={validateIntegrationName}
                  onInput={truncateInputValue(50)}
                  error={errors[integrationName]}
                  placeholder={integrationName.placeholder ? integrationName.placeholder : ""}
                  required={true}
                />
                <FormField
                  type={description.type}
                  label={description.label}
                  name={description.name}
                  onInput={truncateInputValue(500)}
                  error={errors[description]}
                  placeholder={description.placeholder ? description.placeholder : ""}
                  isMultiline
                  rows={2}
                />
              </SoftBox>
            </SoftBox>
            <FormField
              type={version.type}
              label={version.label}
              name={version.name}
              error={errors[version]}
              placeholder={version.placeholder ? version.placeholder : ""}
              required={true}
            />
          </Form>
        );
      }}
    </Formik>
  );
};
